import apiService from '../../apiService'
import Notification from '../../../../../../../resources/js/notification'

const DOCUMENTS_DEFAULT_VALUE = null

export default {
  namespaced: true,
  state: {
    everyMonthReports: DOCUMENTS_DEFAULT_VALUE,
    bookkeepingDocuments: DOCUMENTS_DEFAULT_VALUE
  },
  mutations: {
    setEveryMonthReports (state, payload) {
      state.everyMonthReports = payload || DOCUMENTS_DEFAULT_VALUE
    },
    setBookkeepingDocuments (state, payload) {
      state.bookkeepingDocuments = payload || DOCUMENTS_DEFAULT_VALUE
    }
  },
  actions: {
    fetch ({ state, commit }, domain) {
      apiService.getExistenceNewReports(domain)
        .then(response => {
          commit('setEveryMonthReports', response.data.every_month_reports)
          commit('setBookkeepingDocuments', response.data.bookkeeping_documents)
        })
        .catch(() => {
          commit('setEveryMonthReports')
          commit('setBookkeepingDocuments')

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию о наличии новых отчетов.'
          })
        })
    }
  }
}
